import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import { Message, Button, Confirm } from 'semantic-ui-react';

import withPagination from './WithPagination';
import LoadingDataEnhancer from './LoadingData';
import auctionAccessBlackListsQuery from '../graphql/auctionAccessBlackListsQuery';
import createAuctionAccessBlacklistMutation from '../graphql/createAuctionAccessBlacklistMutation';
import updateAuctionAccessBlacklistMutation from '../graphql/updateAuctionAccessBlacklistMutation';
import deleteAuctionAccessBlacklistMutation from '../graphql/deleteAuctionAccessBlacklistMutation';

import Search from '../views/Shared/Search';
import AuctionAccessBlacklistsNew from '../views/AuctionAccessBlacklists/New';
import AuctionAccessBlacklistsEdit from '../views/AuctionAccessBlacklists/Edit';
import AuctionAccessBlacklistsList from '../views/AuctionAccessBlacklists/List';
import { setSearch } from '../data/searchField/actions';
import { setPage } from '../data/page/actions';

class AuctionAccessBlacklists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAuctionAccessBlacklist: null,
      isEditModalOpen: false,
      isDeleteConfirmationOpen: false,
      isNewModalOpen: false,
      newFormError: null,
      newFormSubmitting: null,
      flashMessage: null,
      editFormError: null,
      editFormSubmitting: null,
    };
  }

  onSearchSubmitHandler = event => {
    const { auctionAccessNumber } = event.target;
    const { data, setSearchFields: setSearchFieldsAction, setPage: setPageAction } = this.props;
    const variableArguments = {
      auctionAccessNumber: auctionAccessNumber.value || null,
    };

    data.refetch({
      ...variableArguments,
    });

    setSearchFieldsAction(variableArguments);
    setPageAction({});
  };

  onSelectAuctionAccessBlacklist = (action, auctionAccessBlacklist) => {
    this.setState({
      selectedAuctionAccessBlacklist: auctionAccessBlacklist,
    });

    switch (action) {
      case 'Edit':
        this.setState({
          isEditModalOpen: true,
        });
        break;
      case 'Delete':
        this.setState({
          isDeleteConfirmationOpen: true,
        });
        break;
      default:
        this.setState({
          selectedAuctionAccessBlacklist: null,
        });
    }
  };

  openNewForm = () => {
    this.setState({ isNewModalOpen: true });
  };

  onNewFormCloseHandler = () => {
    this.setState({
      newFormError: null,
      newFormSubmitting: null,
      isNewModalOpen: false,
    });
  };

  onNewFormSubmitHandler = values => {
    const { createMutation, data } = this.props;
    const input = { auctionAccessBlacklist: { ...values } };
    this.setState({
      newFormSubmitting: true,
    });
    createMutation({
      variables: { input },
    })
      .then(({ data: mutationData }) => {
        const { createAuctionAccessBlacklist: { success, errors } } = mutationData;
        if (success) {
          this.setState({
            newFormSubmitting: false,
            flashMessage: 'Successfully Created Auction Access Blacklist',
          });
          data.refetch();
          this.onNewFormCloseHandler();
        } else {
          this.setState({
            newFormSubmitting: false,
            newFormError: errors,
          });
        }
      })
      .catch(() => {
        this.setState({
          newFormSubmitting: false,
          newFormError: 'Error while creating AuctionAccess blacklist',
        });
      });
  };

  onEditFormCloseHandler = () => {
    this.setState({
      editFormError: null,
      editFormSubmitting: null,
      isEditModalOpen: false,
    });
  };

  onEditFormSubmitHandler = values => {
    const { updateMutation, data, setPage: setPageAction } = this.props;
    const input = { auctionAccessBlacklist: { ...values } };
    this.setState({
      editFormSubmitting: true,
    });
    updateMutation({
      variables: { input },
    })
      .then(({ data: mutationData }) => {
        const { updateAuctionAccessBlacklist: { success, errors } } = mutationData;
        if (success) {
          this.setState({
            editFormSubmitting: false,
            flashMessage: 'Successfully Updated AuctionAccess blacklist',
          });
          data.refetch();
          setPageAction({});
          this.onEditFormCloseHandler();
        } else {
          this.setState({
            editFormSubmitting: false,
            editFormError: errors,
          });
        }
      })
      .catch(error => {
        this.setState({
          editFormSubmitting: false,
          editFormError: error,
        });
      });
  };

  handleDeleteConfirm = () => {
    const { deleteMutation, data, setPage: setPageAction } = this.props;
    const { selectedAuctionAccessBlacklist: { id } } = this.state;
    const input = { auctionAccessBlacklistId: id };
    deleteMutation({
      variables: { input },
    })
      .then(({ data: mutationData }) => {
        const { deleteAuctionAccessBlacklist: { success } } = mutationData;
        if (success) {
          this.setState({
            flashMessage: 'Successfully Deleted Auction Access blacklist',
          });

          data.fetchMore({
            updateQuery: (
              previousResult,
              { fetchMoreResult }
            ) => {
              return fetchMoreResult;
            },
          });
          setPageAction({});
        } else {
          this.setState({
            flashMessage: 'Deleting Auction Access blacklist not Success',
          });
        }
        this.setState({ isDeleteConfirmationOpen: false });
      })
      .catch(() => {
        this.setState({
          isDeleteConfirmationOpen: false,
          flashMessage: 'Deleting Auction Access blacklist not Success',
        });
      });
  };

  handleDeleteCancel = () => {
    this.setState({ isDeleteConfirmationOpen: false });
  };

  handleDismiss = () => {
    this.setState({ flashMessage: null });
  };

  render() {
    const { data: { auctionAccessBlackLists }, searchFields } = this.props;
    const {
      isNewModalOpen,
      newFormError,
      newFormSubmitting,
      isEditModalOpen,
      editFormError,
      editFormSubmitting,
      selectedAuctionAccessBlacklist,
      flashMessage,
      isDeleteConfirmationOpen,
    } = this.state;

    return (
      <div>
        {flashMessage && (
          <Message
            onDismiss={this.handleDismiss}
            content={flashMessage}
            positive
          />
        )}
        <Button color='green' onClick={this.openNewForm} inverted>
          {' '}
          Create New Auction Access Blacklist
        </Button>
        <br />
        <br />
        <Search
          onSubmit={this.onSearchSubmitHandler}
          searchFields={searchFields}
          searchOptions={['auctionAccessNumber']}
        />

        {isNewModalOpen && (
          <div>
            <AuctionAccessBlacklistsNew
              isModalOpen={isNewModalOpen}
              onCloseHandler={this.onNewFormCloseHandler}
              onSubmitHandler={this.onNewFormSubmitHandler}
              error={newFormError}
              submitting={newFormSubmitting}
            />
          </div>
        )}

        {isEditModalOpen && (
          <div>
            <AuctionAccessBlacklistsEdit
              isModalOpen={isEditModalOpen}
              onCloseHandler={this.onEditFormCloseHandler}
              onSubmitHandler={this.onEditFormSubmitHandler}
              error={editFormError}
              submitting={editFormSubmitting}
              auctionAccessBlacklist={selectedAuctionAccessBlacklist}
            />
          </div>
        )}

        <AuctionAccessBlacklistsList
          onSelectAuctionAccessBlacklist={this.onSelectAuctionAccessBlacklist}
          auctionAccessBlackLists={auctionAccessBlackLists}
        />
        <Confirm
          open={isDeleteConfirmationOpen}
          onCancel={this.handleDeleteCancel}
          onConfirm={this.handleDeleteConfirm}
        />
      </div>
    );
  }
}

AuctionAccessBlacklists.propTypes = {
  data: PropTypes.shape({
    refetch: PropTypes.func,
    fetchMore: PropTypes.func,
    auctionAccessBlackLists: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  setSearchFields: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  createMutation: PropTypes.func.isRequired,
  updateMutation: PropTypes.func.isRequired,
  deleteMutation: PropTypes.func.isRequired,
  searchFields: PropTypes.shape({}).isRequired,
};

const mapDispatchToProps = dispatch => ({
  setSearchFields: fields => {
    dispatch(setSearch(fields));
  },
  setPage: () => {
    dispatch(setPage());
  },
});

const mapStateToProps = state => {
  const { data: { searchFields } } = state;
  return {
    searchFields,
  };
};

export default compose(
  withRouter,
  withPagination(auctionAccessBlackListsQuery, 'auctionAccessBlackLists'),
  graphql(createAuctionAccessBlacklistMutation, { name: 'createMutation' }),
  graphql(updateAuctionAccessBlacklistMutation, { name: 'updateMutation' }),
  graphql(deleteAuctionAccessBlacklistMutation, { name: 'deleteMutation' }),
  LoadingDataEnhancer,
  connect(mapStateToProps, mapDispatchToProps)
)(AuctionAccessBlacklists);
